module.exports = __webpack_public_path__ + "img/H3.624f3779.png";